import { useState } from "react";
import "./signInOut.css";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { Bounce, toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import api from "../api";
import logo from "../Assets/Images/Logo.png";
const SignInOut = () => {
  const [formState, setFormState] = useState("signIn");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [nome, setNome] = useState("");
  const [cognome, setCognome] = useState("");
  const [mail, setMail] = useState("");
  const [codiceFis, setCodiceFis] = useState("");
  const [cellulare, setCellulare] = useState("");
  const [citta, setCitta] = useState("");
  const [via, setVia] = useState("");
  const [cap, setCap] = useState("");
  const [provincia, setProvincia] = useState("");
  const [sesso, setSesso] = useState("");
  const [dataNascita, setDataNascita] = useState("");
  const [statoOccup, setStatoOccup] = useState("");
  const [livelloIng, setLivelloIng] = useState("");
  const [livelloInfor, setLivelloInfor] = useState("");
  const [passwordLogin, setPasswordLogin] = useState("");
  const [errorsSignin, setErrorsSignin] = useState({});
  const [errorsSignUp, setErrorsSignUp] = useState({});
  const [signinError, setSigninError] = useState("");
  const [signupError, setSignupError] = useState("");
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotPasswordMessage, setForgotPasswordMessage] = useState("");
  const [showPasswordLogin, setShowPasswordLogin] = useState(false);
  const [showPasswordSignup, setShowPasswordSignup] = useState(false);
  const navigate = useNavigate();
  const [step, setStep] = useState(1);

  const emailRegEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const nameRegEx = /^[A-Za-zÀ-ÿ' -]{2,50}$/;
  const codiceFisRegEx =
    /^[A-Z]{6}[0-9]{2}[A-EHLMPRST][0-9]{2}[A-Z][0-9]{3}[A-Z]$/;
  const capRegEx = /^\d{5}$/;
  const passRegEx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
  const minTwoCharsRegEx = /^[A-Za-z0-9À-ÿ' -]{2,}$/;

  const isValidLogin = () => {
    const errorsLogin = {};
    if (email === "") {
      errorsLogin.email = "Inserisci un indirizzo email!";
    } else if (passwordLogin === "") {
      errorsLogin.passwordLogin = "Inserisci una password!";
    }
    setErrorsSignin(errorsLogin);
    return Object.keys(errorsLogin).length === 0;
  };

  const handleSignin = async () => {
    if (!isValidLogin()) {
      return;
    }

    const userToLogin = { email: email, password: passwordLogin };
    try {
      const response = await api.post("/auth/login", userToLogin);

      if (response.status === 200) {
        const { access_token, refresh_token } = response.data;
        const access_tokenConsole = jwtDecode(access_token);
        const userRole = access_tokenConsole.role;
        localStorage.setItem("userRole", userRole);
        localStorage.setItem("accessToken", access_token);
        localStorage.setItem("refreshToken", refresh_token);

        if (userRole === "ADMIN") {
          navigate("/docenti");
        } else if (userRole === "TRAINER") {
          navigate("/ricerche/posizioni-aperte");
        } else if (userRole === "OPERATOR") {
          navigate("/docenti/disponibile");
        }
      } else {
        setSigninError("L'utente non esiste!");
        return;
      }
    } catch (error) {
      console.log(error);
      setSigninError(error.message);
      if (error.response) {
        console.log(error.response.status);
      } else {
        console.error("Network error:", error.message);
      }

      if (error.response.status === 400) {
        setSigninError("Email o password non validi!");
      } else if (error.response.status === 401) {
        setSigninError("Credenziali non valide!");
      }
    }
  };

  const handleSignup = async () => {
    if (!isValidSignupStep2()) {
      return;
    }

    try {
      const response = await api.post(
        "/auth/register",
        {
          nome,
          cognome,
          sesso,
          role: "TRAINER",
          email: mail,
          password: password,
          codiceFiscale: codiceFis,
          cellulare,
          cittàDiResidenza: citta,
          via,
          cap,
          provincia,
          dataDiNascita: dataNascita,
          statoOccupazionale: statoOccup,
          livelloInglese: livelloIng,
          livelloInformatica: livelloInfor,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        const { access_token, refresh_token } = response.data;
        const access_tokenConsole = jwtDecode(access_token);
        localStorage.setItem("userEmail", access_tokenConsole.sub);
        localStorage.setItem("userRole", "TRAINER");

        localStorage.setItem("accessToken", access_token);
        localStorage.setItem("refreshToken", refresh_token);

        navigate("/ricerche/posizioni-aperte");
      } else {
        setSignupError("Qualcosa è andato storto!");
        return;
      }
    } catch (error) {
      console.error(error);
      if (error.status !== 500) {
        setSignupError(
          error.response.data.message || "Qualcosa è andato storto!"
        );
      } else {
        setSignupError("Qualcosa è andato storto!");
      }
    }
  };

  const handleForgotPassword = async () => {
    if (!emailRegEx.test(forgotEmail)) {
      setForgotPasswordMessage("Inserisci un'email valida.");
      return;
    }

    try {
      const response = await api.post("/reset-password/forgot", {
        email: forgotEmail,
      });

      if (response.status === 200) {
        setForgotPasswordMessage("Email per il reset della password inviata!");
        toast.success("Email per il reset della password inviata!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        setForgotEmail("");
      } else {
        setForgotPasswordMessage("Qualcosa è andato storto! Riprova!");
      }
    } catch (error) {
      console.error(error);
      setForgotPasswordMessage("Errore nel tentativo di recupero password!");
      toast.error("Errore nel tentativo di recupero password!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  const isValidSignupStep1 = () => {
    const partialErrors = {};

    if (nome === "") partialErrors.nome = "Inserisci il tuo nome!";
    else if (!nameRegEx.test(nome))
      partialErrors.nome = "Il nome può contenere solo lettere!";

    if (cognome === "") partialErrors.cognome = "Inserisci il tuo cognome!";
    else if (!nameRegEx.test(cognome))
      partialErrors.cognome = "Il cognome può contenere solo lettere!";

    if (codiceFis === "")
      partialErrors.codiceFis = "Inserisci il tuo codice fiscale!";
    else if (!codiceFisRegEx.test(codiceFis))
      partialErrors.codiceFis = "Formato Codice fiscale non valido!";

    if (mail === "") partialErrors.mail = "Inserisci la tua email!";
    else if (!emailRegEx.test(mail))
      partialErrors.mail = "Formato email non valido!";

    if (cellulare === "")
      partialErrors.cellulare = "Inserisci il tuo cellulare!";
    else if (!/^\d+$/.test(cellulare))
      partialErrors.cellulare = "Il cellulare deve contenere solo cifre!";

    if (password === "") partialErrors.password = "Inserisci la tua password!";
    else if (!passRegEx.test(password))
      partialErrors.password =
        "La password deve contenere almeno 8 caratteri, una maiuscola, una minuscola, un numero e un simbolo.";

    setErrorsSignUp(partialErrors);
    return Object.keys(partialErrors).length === 0;
  };

  const isValidSignupStep2 = () => {
    const partialErrors = {};

    if (sesso === "") partialErrors.sesso = "Inserisci il tuo sesso!";

    if (citta === "")
      partialErrors.citta = "Inserisci la tua città di residenza!";
    else if (!minTwoCharsRegEx.test(citta))
      partialErrors.citta = "La città deve contenere almeno 2 caratteri!";

    if (via === "") partialErrors.via = "Inserisci la tua via!";
    else if (!minTwoCharsRegEx.test(via))
      partialErrors.via = "La via deve contenere almeno 2 caratteri!";

    if (cap === "") partialErrors.cap = "Inserisci la tua CAP!";
    else if (!capRegEx.test(cap))
      partialErrors.cap = "Il CAP deve contenere 5 cifre!";

    if (provincia === "")
      partialErrors.provincia = "Inserisci la tua provincia!";
    else if (!minTwoCharsRegEx.test(provincia))
      partialErrors.provincia =
        "La provincia deve contenere almeno 2 caratteri!";

    if (dataNascita === "")
      partialErrors.dataNascita = "Inserisci la tua data di nascita!";

    if (statoOccup === "")
      partialErrors.statoOccup = "Seleziona il tuo stato occupazionale!";

    if (livelloIng === "")
      partialErrors.livelloIng = "Seleziona il livello di inglese!";

    if (livelloInfor === "")
      partialErrors.livelloInfor = "Seleziona il livello di informatica!";

    setErrorsSignUp(partialErrors);
    return Object.keys(partialErrors).length === 0;
  };

  return (
    <div className={`sign-page ${formState === "signup" ? "sign-up" : ""}`}>
      {formState === "signIn" && (
        <div className="sign-in">
          <div className="container-logo">
            <img src={logo} alt="Fortis Trainer Logo" className="logo" />
          </div>
          <h1 className="sign-in-title">Accedi</h1>
          <div className="sign-in-form">
            <div className="form-group">
              <label>Email</label>
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errorsSignin.email && (
                <span className="error">{errorsSignin.email}</span>
              )}
            </div>
            <div className="form-group">
              <label>Password</label>
              <div className="password-input-wrapper">
                <input
                  type={showPasswordLogin ? "text" : "password"}
                  value={passwordLogin}
                  onChange={(e) => setPasswordLogin(e.target.value)}
                />
                <button
                  type="button"
                  className="toggle-password-btn"
                  onClick={() => setShowPasswordLogin(!showPasswordLogin)}
                  aria-label={showPasswordLogin ? "Nascondi password" : "Mostra password"}
                >
                  <FontAwesomeIcon icon={showPasswordLogin ? faEyeSlash : faEye} />
                </button>
              </div>
              {errorsSignin.passwordLogin && (
                <span className="error">{errorsSignin.passwordLogin}</span>
              )}
            </div>

            {signinError && <span className="auth-error">{signinError}</span>}
            <button className="sign-btn" onClick={handleSignin}>
              Accedi
            </button>
          </div>
          <button
            className="forgot-btn"
            onClick={() => setFormState("forgotPass")}
          >
            Password dimenticata?
          </button>
          <div className="divider">
            <span>oppure</span>
          </div>

          <div className="no-account">
            Non hai un account?{" "}
            <button onClick={() => setFormState("signUp")}>Registrati</button>
          </div>
        </div>
      )}
      {formState === "signUp" && (
        <div className="sign-up">
          <h1 className="sign-up-title">Iscriviti</h1>

          <div className="step-indicator">
            <div className={`step-circle ${step === 1 ? "active" : ""}`}>1</div>
            <div className="step-line"></div>
            <div className={`step-circle ${step === 2 ? "active" : ""}`}>2</div>
          </div>

          {step === 1 && (
            <div className="sign-up-form">
              <div className="form-group">
                <div className="input-group">
                  <label htmlFor="nome">Nome</label>
                  <input
                    type="text"
                    id="nome"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    placeholder="Nome"
                  />
                </div>
                <span className="error">{errorsSignUp.nome}</span>
              </div>

              <div className="form-group">
                <div className="input-group">
                  <label htmlFor="cognome">Cognome</label>
                  <input
                    type="text"
                    id="cognome"
                    value={cognome}
                    onChange={(e) => setCognome(e.target.value)}
                    placeholder="Cognome"
                  />
                </div>
                <span className="error">{errorsSignUp.cognome}</span>
              </div>

              <div className="form-group">
                <div className="input-group">
                  <label htmlFor="codiceFis">Codice Fiscale</label>
                  <input
                    type="text"
                    id="codiceFis"
                    value={codiceFis}
                    onChange={(e) => setCodiceFis(e.target.value)}
                    placeholder="Codice fiscale"
                  />
                </div>
                <span className="error">{errorsSignUp.codiceFis}</span>
              </div>

              <div className="form-group">
                <div className="input-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="text"
                    id="email"
                    value={mail}
                    onChange={(e) => setMail(e.target.value)}
                    placeholder="Email"
                  />
                </div>
                <span className="error">{errorsSignUp.mail}</span>
              </div>

              <div className="form-group">
                <div className="input-group">
                  <label>Password</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showPasswordSignup ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="toggle-password-btn"
                      onClick={() => setShowPasswordSignup(!showPasswordSignup)}
                      aria-label={showPasswordSignup ? "Nascondi password" : "Mostra password"}
                    >
                      <FontAwesomeIcon icon={showPasswordSignup ? faEyeSlash : faEye} />
                    </button>
                  </div>
                </div>
                <span className="error">{errorsSignUp.password}</span>
              </div>

              <div className="form-group">
                <div className="input-group">
                  <label htmlFor="cellulare">Cellulare</label>
                  <input
                    type="text"
                    id="cellulare"
                    value={cellulare}
                    onChange={(e) => setCellulare(e.target.value)}
                    placeholder="Cellulare"
                  />
                </div>
                <span className="error">{errorsSignUp.cellulare}</span>
              </div>

              <button
                className="sign-btn"
                onClick={() => {
                  const validStep1 = isValidSignupStep1();
                  if (validStep1) setStep(2);
                }}
              >
                Avanti
              </button>
            </div>
          )}

          {step === 2 && (
            <div className="sign-up-form">
              <div className="form-group">
                <div className="input-group">
                  <label htmlFor="sesso">Sesso</label>
                  <select
                    id="sesso"
                    value={sesso}
                    onChange={(e) => setSesso(e.target.value)}
                  >
                    <option value="" disabled>
                      Seleziona...
                    </option>
                    <option value="MASCHIO">Maschio</option>
                    <option value="FEMMINA">Femmina</option>
                    <option value="ALTRO">Altro</option>
                  </select>
                </div>
                <span className="error">{errorsSignUp.sesso}</span>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <label htmlFor="citta">Città di Residenza</label>
                  <input
                    type="text"
                    value={citta}
                    id="citta"
                    onChange={(e) => setCitta(e.target.value)}
                    placeholder="Città di Residenza"
                  />
                </div>
                <span className="error">{errorsSignUp.citta}</span>
              </div>

              <div className="form-group">
                <div className="input-group">
                  <label htmlFor="via">Via</label>
                  <input
                    type="text"
                    value={via}
                    id="via"
                    onChange={(e) => setVia(e.target.value)}
                    placeholder="Via"
                  />
                </div>
                <span className="error">{errorsSignUp.via}</span>
              </div>

              <div className="form-group">
                <div className="input-group">
                  <label htmlFor="cap">CAP</label>
                  <input
                    type="text"
                    value={cap}
                    id="cap"
                    onChange={(e) => setCap(e.target.value)}
                    placeholder="CAP"
                  />
                </div>
                <span className="error">{errorsSignUp.cap}</span>
              </div>

              <div className="form-group">
                <div className="input-group">
                  <label htmlFor="provincia">Provincia</label>
                  <input
                    type="text"
                    value={provincia}
                    id="provincia"
                    onChange={(e) => setProvincia(e.target.value)}
                    placeholder="Provincia"
                  />
                </div>
                <span className="error">{errorsSignUp.provincia}</span>
              </div>

              <div className="form-group">
                <div className="input-group">
                  <label htmlFor="dataNascita">Data di Nascita</label>
                  <input
                    type="date"
                    value={dataNascita}
                    id="dataNascita"
                    onChange={(e) => setDataNascita(e.target.value)}
                    placeholder="Data di Nascita"
                  />
                </div>
                <span className="error">{errorsSignUp.dataNascita}</span>
              </div>

              <div className="form-group">
                <div className="input-group">
                  <label className="statoOccup">Stato Occupazionale</label>
                  <select
                    value={statoOccup}
                    onChange={(e) => setStatoOccup(e.target.value)}
                    id="statoOccup"
                  >
                    <option value="">Seleziona...</option>
                    <option value="OCCUPATO">Occupato</option>
                    <option value="DISOCCUPATO">Disoccupato</option>
                    <option value="STUDENTE">Studente</option>
                    <option value="IN_CERCA">In cerca</option>
                  </select>
                </div>
                <span className="error">{errorsSignUp.statoOccup}</span>
              </div>

              <div className="form-group">
                <div className="input-group">
                  <label htmlFor="livelloIng">Livello Inglese</label>
                  <select
                    value={livelloIng}
                    id="livelloIng"
                    onChange={(e) => setLivelloIng(e.target.value)}
                  >
                    <option value="">Seleziona...</option>
                    <option value="BASSO">Basso</option>
                    <option value="MEDIO">Medio</option>
                    <option value="ALTO">Alto</option>
                  </select>
                </div>
                <span className="error">{errorsSignUp.livelloIng}</span>
              </div>

              <div className="form-group">
                <div className="input-group">
                  <label htmlFor="livelloInfor">Livello Informatica</label>
                  <select
                    value={livelloInfor}
                    id="livelloInfor"
                    onChange={(e) => setLivelloInfor(e.target.value)}
                  >
                    <option value="">Seleziona...</option>
                    <option value="BASSO">Basso</option>
                    <option value="MEDIO">Medio</option>
                    <option value="ALTO">Alto</option>
                  </select>
                </div>
                <span className="error">{errorsSignUp.livelloInfor}</span>
              </div>

              {signupError && <span className="auth-error">{signupError}</span>}

              <div className="form-buttons">
                <button className="back-btn" onClick={() => setStep(1)}>
                  Indietro
                </button>
                <button className="sign-btn" onClick={handleSignup}>
                  Registrati
                </button>
              </div>
            </div>
          )}

          <div className="yes-account">
            Già registrato?
            <button onClick={() => setFormState("signIn")}>Accedi</button>
          </div>
        </div>
      )}

      {formState === "forgotPass" && (
        <div className="forgot-pass">
          <div className="forgot-pass-title">Forgot</div>
          <div className="form-group">
            <div className="input-group">
              <label htmlFor="forgotEmail">Email</label>
              <input
                type="text"
                id="forgotEmail"
                value={forgotEmail}
                onChange={(e) => setForgotEmail(e.target.value)}
                placeholder="Email"
              />
            </div>
            {forgotPasswordMessage && (
              <span className="auth-error">{forgotPasswordMessage}</span>
            )}

            <button className="forgot-button" onClick={handleForgotPassword}>
              Invia richiesta
            </button>

            <button
              className="return-login"
              onClick={() => setFormState("signIn")}
            >
              Torna al login
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignInOut;
